import { render, staticRenderFns } from "./StatisticsChats.vue?vue&type=template&id=44eb12c4&"
import script from "./StatisticsChats.vue?vue&type=script&lang=js&"
export * from "./StatisticsChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports